import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  text: {
    id: 'seo_blue_beetle_header_text',
  },
  topic: {
    id: 'seo_blue_beetle_header_topic',
  },
});

export const en = defineMessages({
  title: {
    id: 'seo_blue_beetle_header_title_en',
  },
  cta: {
    id: 'seo_blue_beetle_header_cta_en',
  },
});

export const en_us = defineMessages({
  title: {
    id: 'seo_blue_beetle_header_title_en_us',
  },
  cta: {
    id: 'seo_blue_beetle_header_cta_en_us',
  },
});

export const es = defineMessages({
  title: {
    id: 'seo_blue_beetle_header_title_es',
  },
  cta: {
    id: 'seo_blue_beetle_header_cta_es',
  },
});

export const es_mx = defineMessages({
  title: {
    id: 'seo_blue_beetle_header_title_es_mx',
  },
  cta: {
    id: 'seo_blue_beetle_header_cta_es_mx',
  },
});
